import { render, staticRenderFns } from "./GetProduct.vue?vue&type=template&id=072c3deb&scoped=true&"
import script from "./GetProduct.vue?vue&type=script&lang=js&"
export * from "./GetProduct.vue?vue&type=script&lang=js&"
import style0 from "./GetProduct.vue?vue&type=style&index=0&id=072c3deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c3deb",
  null
  
)

export default component.exports